import {
    useCheckoutStore,
    usePaymentsStore,
    useSessionStore,
} from "@/plugins/store";
import { CreatePaymentPayload } from "@/helpers/interfaces/shared";
import {
    TruelayerCreatePaymentPayload,
    VoltProviderInformation,
    LloydsProviderInformation,
} from "@/helpers/interfaces/providers";
import {
    PaymentMethod,
    AdyenProviderInformation,
    IFXProviderInformation,
} from "@esenda/core-ui/interfaces";
import { useOrganisationStore } from "@/plugins/store";

export const createPaymentPayload = (
    providerInformation:
        | TruelayerCreatePaymentPayload
        | VoltProviderInformation
        | LloydsProviderInformation
        | AdyenProviderInformation
        | IFXProviderInformation
        | null,
): CreatePaymentPayload | null => {
    /**
     * Creates the payment payload for provider specific payments
     * @param  {[ TruelayerCreatePaymentPayload | VoltProviderInformation | LloydsProviderInformation | AdyenProviderInformation | IFXProviderInformation | null]} providerInformation
     * @return {[CreatePaymentPayload]}
     */
    const sessionStore = useSessionStore();
    const orgStore = useOrganisationStore();
    const checkoutStore = useCheckoutStore();
    const paymentStore = usePaymentsStore();
    if (!paymentStore.paymentMethods) return null;
    // Find the payment method that matches the selected provider and amount, including card types for card payments
    const paymentMethod: PaymentMethod | undefined =
        paymentStore.selectedProviderDetails ?? undefined;
    if (!paymentMethod) return null;

    const {
        localAmount: amount = "",
        localCurrencyCode: currencyCode = "",
        quoteId = null,
    } = paymentMethod;

    if (!amount || !currencyCode) return null;

    const payload = {
        shortcode: orgStore.shortcode,
        emailAddress: sessionStore.emailAddress,
        paymentForm: orgStore.formName,
        amount: amount,
        currencyCode: currencyCode,
        formData: checkoutStore.supplementaryData,
        providerInformation: providerInformation,
        ...(quoteId && { quoteId }),
        ...(paymentStore.paymentId && { paymentId: paymentStore.paymentId }),
        ...(checkoutStore.orderId && { orderId: checkoutStore.orderId }), // Attach orderId to the create payment payload if it's not null
    };

    return payload;
};
